/**
 * Read-only odd display for result panels.
 * Matches the design system of the bet odd box (rounded, border, padding, font-semibold)
 * but is not clickable and uses theme tokens for light/dark consistency.
 */
import React from 'react';
import { printOdd } from 'shared/utils/common';

export type ResultOddChipProps = {
  odd: number | null | undefined;
  oddsFormat?: string;
  className?: string;
};

export default function ResultOddChip({ odd, oddsFormat = 'decimal', className = '' }: ResultOddChipProps) {
  const text = odd != null && Number.isFinite(Number(odd)) ? printOdd(Number(odd), oddsFormat) : '—';
  return (
    <span
      className={
        'inline-flex items-center justify-center min-h-[2rem] px-2 py-1 rounded-md border border-border bg-background text-foreground text-sm font-semibold tabular-nums ' +
        className
      }
      aria-hidden
    >
      {text}
    </span>
  );
}
